import actionTypes from '../actions/types';
import { decimalPlaces } from '../utils/number';

export const INITIAL_STATE = {
  tickers: {},
  tickSizes: {},
  minTrades: {},
};

const handleSetProducts = (state, { data }) => {
  const newState = { ...state };
  const tickSizes = {};
  const minTrades = {};
  if (Array.isArray(data) && data.length !== 0) {
    newState.tickers = data.reduce((tickers, symbolInfo) => {
      // eslint-disable-next-line
      // convert the the symbol info from the `/product` api to ticker update format.
      const {
        l, // low
        c, // close
        h, // high
        o, // open
        v, // volume
        qv: q, // tradedMoney，即QuoteVolume
        s, // symbol
        ts, // tickSize
        i: mt, // minQty
        q: qa, // quoteAsset
        b: ba, // baseAsset
        an: bn, // baseAssetName
        pm, // parentMarket
        pn, // parentMarketName
        cs,
      } = symbolInfo;
      const t = Date.now();
      tickers[s] = { t, s, l, c, h, o, q, v, qa, ba, bn, pm, pn, tickSize: ts, minTrade: mt, cs }; // eslint-disable-line
      tickSizes[s] = decimalPlaces(ts.toString()) || 8;
      minTrades[s] = decimalPlaces(mt.toString()) || 8;
      return tickers;
    }, {});
  }
  newState.tickSizes = tickSizes;
  newState.minTrades = minTrades;
  return newState;
};

export const handleUpdateTickers = (state, tickers) => {
  const newState = { ...state, tickers: { ...(state.tickers || {}) } };
  let updated = false;
  const t = Date.now();
  tickers.forEach(ticker => {
    delete ticker.e; // "24hrMiniTicker"
    ticker.t = t;
    const existing = state.tickers[ticker.s];
    if (!existing) {
      newState.tickers[ticker.s] = ticker;
      updated = true;
      // existing changed?
    } else if (Object.keys(ticker).some(key => ticker[key] !== existing[key])) {
      newState.tickers[ticker.s] = { ...state.tickers[ticker.s], ...(ticker || {}) };
      updated = true;
    }
  });
  return updated ? newState : state;
};

export const handleUpdateTickersMap = (state, tickersMap) => {
  const tickers = {
    ...(state.tickers || {}),
  };

  Object.keys(tickersMap).forEach(symbol => {
    const t = performance.now() || Date.now();
    tickers[symbol] = symbol in tickers
      ? {
        ...tickers[symbol],
        ...tickersMap[symbol],
        t,
      }
      : { ...tickersMap[symbol], t };
  });

  return {
    ...state,
    tickers,
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_PRODUCTS:
      return handleSetProducts(state, action);
    default:
      return state;
  }
};
